import { createSlice } from '@reduxjs/toolkit';

import { WordBoundary } from 'js/types';

export interface AudioWordformsState {
  state: 'loading' | 'loaded' | 'error';
  wordBoundaries?: WordBoundary[];
  error?: string;
}

const initialState: {
  [assetId: number]: AudioWordformsState;
} = {};

const audioWordformsSlice = createSlice({
  name: 'audioWordforms',
  initialState,
  reducers: {
    getWordBoundariesRequested: (state, action: { payload: { assetId: number } }) => {
      const { assetId } = action.payload;
      state[assetId] = { state: 'loading' };
    },
    getWordBoundariesSuccess: (state, action: { payload: { assetId: number; wordBoundaries: WordBoundary[] } }) => {
      const { assetId, wordBoundaries } = action.payload;
      state[assetId] = { state: 'loaded', wordBoundaries };
    },
    getWordBoundariesFailure: (state, action: { payload: { assetId: number; error: string } }) => {
      const { assetId, error } = action.payload;
      state[assetId] = { state: 'error', error };
    }
  },
  selectors: {
    selectWordBoundaries: (state: typeof initialState, assetId: number) => {
      return state[assetId];
    }
  }
});

export const { getWordBoundariesRequested, getWordBoundariesSuccess, getWordBoundariesFailure } =
  audioWordformsSlice.actions;
export const { selectWordBoundaries } = audioWordformsSlice.selectors;

export default audioWordformsSlice.reducer;
